<template>
  <div>
    <!-- 多箱取消装箱 -->
    <el-dialog :title="$t('message.CancelPackingMultipleBoxes')" :close-on-click-modal="false"
      :visible.sync="dialogVisible" width="1208px" center>
      <div class="content">
        <!-- 当前箱号 -->
        <div class="boxNum">
          {{ $t("message.presentBoxNum") }}:
          <span v-for="(box) in selectBox">{{ box }}、</span>
        </div>
        <div class="table">
          <ol>
            <!-- 订单号 -->
            <li class="flex15">{{ $t("message.orderNumber") }}</li>
            <!--  番号-->
            <li class="flex05">
              {{ $t("message.mash") }}
            </li>

            <!--照片-->
            <li>
              {{ $t("message.pic") }}
            </li>
            <!-- 商品属性 -->
            <li class="flex15">{{ $t("message.commodityAttribute") }}</li>
            <!-- 商品费用 -->
            <li>{{ $t("message.forGoods") }}</li>
            <!-- 提出数 -->
            <li>
              {{ $t("message.putForwardNum") }}
            </li>

            <!-- 当前已装箱数 -->
            <li>{{ $t("message.CurrentNumberBoxed") }}</li>

          </ol>
          <!-- 订单详情 -->

          <ul v-for="(item, index) in tableData" :key="index">

            <!-- 订单号 -->
            <li class="flex15">
              <div>
                <p>{{ item.order_sn }}</p>
                <p>{{ item.realname }}</p>
              </div>
            </li>
            <!--   番号-->
            <li class="flex05">
              {{ item.sorting }}
            </li>
            <!--照片-->
            <li>
              <div>
                <div class="img">
                  <el-popover placement="right" width="300" trigger="hover">
                    <img :src="item.pic" alt="" style="width: 300px; height: 300px" />
                    <a :href="`https://detail.1688.com/offer/${item.goods_id}.html`" target="_blank" slot="reference">
                      <img :src="item.pic" alt="" style="width: 60px; height: 60px" />
                    </a>
                  </el-popover>
                </div>
              </div>
            </li>
            <!-- 商品属性 -->
            <li class="flex15">
              <div class="template">
                <el-tooltip placement="bottom">
                  <div slot="content">
                    <div class="row" v-for="(itemDetail, itemIndex) in item.detail_y" :key="itemIndex"
                      style="margin-bottom: 5px">
                      {{ itemDetail.key }}：{{ itemDetail.value }}
                    </div>
                  </div>
                  <div>
                    <div class="row" v-for="(itemDetail, itemIndex) in item.detail_y" :key="itemIndex">
                      {{ itemDetail.key }}：{{ itemDetail.value }}
                    </div>
                  </div>
                </el-tooltip>
              </div>
            </li>
            <!-- 价格.元 -->
            <li>
              <div>
                <p>{{ $t("message.price") }}:{{ item.confirm_price }}</p>
                <p>{{ $t("message.freight") }}:{{ item.confirm_freight }}</p>
              </div>
            </li>

            <!-- 提出数 -->
            <li>
              {{ item.confirm_num }}
            </li>

            <!-- 当前已装箱数 -->
            <li>{{ item.in_box_num }}</li>

          </ul>

        </div>
      </div>

      <span slot="footer" class="dialog-footer">

        <!-- 确认无误 -->
        <el-button type="primary" @click="confirmedWithoutError" v-if="isAuth(248)">
          {{ $t("message.ConfirmedWithoutError") }}
        </el-button>
      </span>
    </el-dialog>
    <!-- 仓库 -->
    <warehouse v-if="warehouseDialogVisible" :type="6" :shelf_type_set="[1, 2, 3, 4]"
      :cancelEncasementData="cancelEncasementData" />
  </div>
</template>
<script>
import warehouse from "@/components/common/warehouse";
import { mapState } from "vuex";
export default {
  components: {
    warehouse,
  },
  data() {
    return {
      dialogVisible: false,
      porder_sn: this.$route.query.porder_sn,
      id: "",
      tableData: [],
      warehouseDialogVisible: false, //仓库
      cancelEncasementData: {}, //取消装箱数据
    };
  },
  computed: {
    ...mapState({
      boxDetail: (state) => state.porderDetail.boxDetail,
      boxList: (state) => state.porderDetail.boxList,
      boxStatus: (state) => state.porderDetail.boxStatus,
      status: (state) => state.porderDetail.status,
      boxIds: (state) => state.porderDetail.boxIds,
      selectBox: (state) => state.porderDetail.selectBox,
    }),

  },
  watch: {
    dialogVisible() {
      if (this.dialogVisible) {
        this.freightDetailBatch()
      }
    }
  },
  created() { },
  methods: {
    freightDetailBatch() {
      let datas = {
        freight_id_set: this.boxIds,
      };
      this.tableData = []

      this.$api.porderApi.freightDetailBatch(datas).then((res) => {
        this.tableData = res.data
      });
    },
    // 确认无误
    confirmedWithoutError() {
      this.cancelEncasementData = {
        grid_number: '',
        freight_id_set: this.boxIds,

      };
      this.warehouseDialogVisible = true
    },
    // 取出箱子成功
    takeOutSucess() {
      this.dialogVisible = false;
      this.warehouseDialogVisible = false;
      this.$store.dispatch("porderDetail", { porder_sn: this.porder_sn });
    },

  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0 15px;

  .boxNum {
    font-size: 18px;
    margin-bottom: 10px;
  }

  .table {
    .head {
      line-height: 40px;
      font-size: 18px;
      border-bottom: 1px solid #dedede;
    }

    .template {
      width: 100%;
      text-align: left;
    }

    .flex05 {
      flex: 0.5;
    }

    .flex15 {
      flex: 1.5;
    }

    .flex2 {
      flex: 2;
    }

    .row {
      display: flex;
      margin-bottom: 5px;
      line-height: 32px;

      &:nth-last-child(1) {
        margin: 0;
      }

      span {
        flex: 3;

        &:nth-child(2) {
          flex: 1;
        }
      }
    }
  }
}

.box {
  border-radius: 8px;
  margin: 24px 15px 0;

  .box-title {
    text-align: center;
    margin: 48px 0 24px;
    font-size: 18px;
  }

  h6 {
    font-size: 18px;
    margin-bottom: 10px;
  }

  .box-list {
    padding: 0 40px;
    background-color: #e8e8e8;
    display: flex;
    flex-wrap: wrap;
    border-radius: 8px;

    .item {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 288px;
      border-right: 1px solid #edeff4;
      border-bottom: 1px solid #edeff4;
      padding: 20px 0;

      .item-box {
        display: flex;
        justify-content: center;
        align-items: center;

        /deep/.el-radio__input {
          transform: scale(1.5);
        }

        /deep/ .el-radio__label {
          display: none;
        }

        .el-checkbox {
          margin-right: 20px;
        }

        .item-content {
          padding: 15px;
          border: 1px solid #edeff4;
          border-radius: 4px;
          background-color: #fff;
          width: 178px;
          cursor: pointer;

          .remark {
            margin-bottom: 14px;
          }

          .NO {
            color: #999;
          }
        }
      }
    }
  }
}
</style>
